import { useCallback } from 'react';

import { useGetProcessingReferralRequestsQuery } from '../../generated/home';

const useProcessingReferralRequests = () => {
  const [{ data, error }, reexecuteQuery] = useGetProcessingReferralRequestsQuery({
    requestPolicy: 'cache-and-network',
  });

  const refetch = useCallback(() => reexecuteQuery({ requestPolicy: 'network-only' }), [reexecuteQuery]);

  return { error, processingReferralRequests: data?.getProcessingReferralRequests ?? [], refetch };
};

export { useProcessingReferralRequests };
